export default class Command {
    constructor(item) {
        this.id = item != null ? item.id : ''
        this.triggerId = item != null ? item.triggerId : ''
        this.naam = item != null ? item.naam : '' 
        this.keywords = item != null ? item.keywords : ''
        this.modifiers = item != null ? item.modifiers : ''
        this.factuurnummer = item != null ? item.factuurnummer : ''
        this.factuurdatum = item != null ? item.factuurdatum : ''
        this.referentie = item != null ? item.referentie : ''
        this.totaalbedrag = item != null ? item.totaalbedrag : ''
        this.subtotaal = item != null ? item.subtotaal : ''
        this.btwLaag = item != null ? item.btwLaag : ''
        this.btwHoog = item != null ? item.btwHoog : ''
        this.kostenLaag = item != null ? item.kostenLaag : ''
        this.kostenHoog = item != null ? item.kostenHoog : ''
        this.kostenNul = item != null ? item.kostenNul : ''
        this.kostenVerlegd = item != null ? item.kostenVerlegd : ''
        this.testcontent = item != null ? item.testcontent : ''
        this.testfilename = item != null ? item.testfilename : ''
    }
}